import styled from 'styled-components';

/**
 * stile condiviso per le label dei dati del riepilogo esteso.
 */
export const SummaryTextLabel = styled.div`
  font-weight: 600;
  color: ${props => props.theme.colorTextSecondary};
  font-size: 0.85em;
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;
